export default __webpack_public_path__ + "static/media/arcade.e0535ba4.png";